/**
 * Segmento de URL para `/api/customer/{clientCode}/me` en perfil global.
 * Valores reservados en API (sin fila en Clientes): `global`, `__global__`.
 * Si definís `VUE_APP_GLOBAL_ACCOUNT_CLIENT_CODE`, puede ser un código de tienda real
 * (comportamiento anterior) o uno de los reservados.
 */
export function getGlobalAccountClientCode () {
  const v = process.env.VUE_APP_GLOBAL_ACCOUNT_CLIENT_CODE
  if (v != null && String(v).trim() !== '') return String(v).trim()
  return 'global'
}
